import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthRequestDTO } from 'src/app/core/models/AuthRequestDTO';
import { ListRoleDTO } from 'src/app/core/models/ListRoleDTO';
import { ProfileDTO } from 'src/app/core/models/ProfileDTO';
import { ComplianceState, MoneyFlowsSendState } from 'src/app/core/models/RegStatistics';
import { UserDTO } from 'src/app/core/models/UserDTO';
import { DataLaerService } from 'src/app/core/services/data-laer.service';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { FormService } from 'src/app/core/services/form.service';
import { GeneralService } from 'src/app/core/services/general.service';
import { InteractionService } from 'src/app/core/services/interaction.service';
import { LoginService } from 'src/app/core/services/login.service';
import { RegServiceService } from 'src/app/core/services/reg-service.service';
import { RolesService } from 'src/app/core/services/roles.service';
import { SettingsService } from 'src/app/core/services/settings.service';
import { TwofactorAuthenticationService } from 'src/app/core/services/twofactor-authentication.service';

declare let gtag: any;

interface CanAccessDashboard {
  canViewDashboard: boolean;
  canViewTransaction: boolean;
  canViewBalance: boolean;
  canViewSettings: boolean;
}

interface CanAccessAdminRight {
  canViewTransaction: boolean;
  canViewBalance: boolean;
  canViewVolumes: boolean;
  canViewGoAml: boolean;
  canViewCustomerReport: boolean;
  canViewOrganization: boolean;
  canviewGroup: boolean;
  canViewZone: boolean;
  canViewSettings: boolean;
}

@Component({
  selector: 'app-fake-login',
  templateUrl: './fake-login.component.html',
  styleUrls: ['./fake-login.component.scss'],
})
export class FakeLoginComponent implements OnInit {
  // State flags
  twoFaVerification = false;
  showLoginPage = false;
  showLoader = false;
  showLoader2fa = false;
  showResponseErrorMessage = false;
  showErrorMsg = false;
  showResetModal = false;
  setup2FA = false;
  showApps = false;
  showCard = false;
  showCreatePass = false;
  showPassReset = false;
  showConfirmPass = false;
  showResetLinkSent = false;
  showPasswordChangedSuccess = false;
  showResetLinkErrorMessage = false;
  resetTwoFAFlag = false;
  resetEmailSent = false;
  codeReady = false;
  orgActive = false;
  showNewDashbordMenu = false;
  whatsNewPageFlag = false;
  isLoading = false;
  showResetPassword = false;  // Add this with the other boolean flags


  // Form data
  username = '';
  password = '';
  newPassword = '';
  confirmNewPassword = '';
  passwordResetEmail = '';

  // Messages
  loginMsg = 'Log in';
  errMsg = '';
  responseErrorMessage = '';
  resetLinkErrorMessage = '';
  showOrgStatus = '';

  // Data
  contriesList: any[] = [];
  userProFileInfoDetailes: any;
  moduleName: any;
  moduleStatus: any;
  adminRoleList: ListRoleDTO;
  image: any;
  QRcodeImage: any;
  authenticationKey: any;
  link2fa: string;
  type2fa: string;
  validateId: string;
  createNewPasswordToken: string;
  createNewPasswordType: string;
  createNewPasswordId: any;
  returnUrl: any;
  id: any;
  firstTimeLoginFlag: any;
  orgFlag: any;
  user2FAFlag: any;
  userFlag: any;
  isChangePassword: any;
  pwd: string;
  step = 0;

  // Access controls
  canAccess: CanAccessDashboard = {
    canViewDashboard: false,
    canViewTransaction: false,
    canViewBalance: false,
    canViewSettings: false,
  };

  canAccessForAdmin: CanAccessAdminRight = {
    canViewTransaction: false,
    canViewBalance: false,
    canViewVolumes: false,
    canViewGoAml: false,
    canViewCustomerReport: false,
    canViewOrganization: false,
    canviewGroup: false,
    canViewZone: false,
    canViewSettings: false,
  };

  private readonly imageType = 'data:image/PNG;base64,';

  constructor(
    public _formService: FormService,
    private _loginService: LoginService,
    private _dataLayerService: DataLaerService,
    private _generalService: GeneralService,
    private _router: Router,
    private _rolesService: RolesService,
    private sanitizer: DomSanitizer,
    private _state: RegServiceService,
    private _interactionService: InteractionService,
    private _settingsService: SettingsService,
    private route: ActivatedRoute,
    private _errorHandlerService: ErrorHandlerService,
    private _twofactorAuthenticationService: TwofactorAuthenticationService
  ) {
    this.initializeComponent();
  }

  ngOnInit(): void {
    this.isCreateNewPasswordRequest();
    this.resetRequest2FA();
  }

  private initializeComponent(): void {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '';
    
    if (localStorage.getItem('reload') === 'true') {
      localStorage.setItem('reload', 'false');
      location.reload();
    }
    
    localStorage.clear();
  }

  // Password reset flow
  isCreateNewPasswordRequest(): void {
    this.validateId = this.route.snapshot.queryParamMap.get('id');
    this.createNewPasswordToken = this.route.snapshot.queryParamMap.get('token');
    this.createNewPasswordType = this.route.snapshot.queryParamMap.get('type');
    
    if (this.createNewPasswordType && this.createNewPasswordToken && this.validateId) {
      this.validateToken();
    } else {
      this.showLogin();
    }
  }

  validateToken(): void {
    this._loginService.validateToken(this.validateId, this.createNewPasswordToken, this.createNewPasswordType)
      .subscribe((response: any) => {
        this._errorHandlerService.checkAndShowpageError(response.responseCode, 'login');
        
        if (response.token) {
          localStorage.setItem('token_key', response.token);
        }
        
        if (response.responseCode === '200') {
          this.createNewPasswordId = response.result.responseData.email;
          this.showResetPasswordMethod();
        } else {
          this.handleInvalidTokenResponse(response);
        }
      });
  }

  private handleInvalidTokenResponse(response: any): void {
    if (this.createNewPasswordType === 'reset') {
      this._generalService.sendNote({
        text: response.responseMessage,
        duration: 5000,
        type: 'success',
      });
    }
    
    setTimeout(() => {
      this._router.navigate(['login']);
    }, 5000);
  }

  isPasswordValid(): boolean {
    const password = this.newPassword;
    return (
      this._formService.containsUppercase(password) &&
      this._formService.containsSpecialChars(password) &&
      this._formService.containsNumbers(password) &&
      password.length >= 8 &&
      password === this.confirmNewPassword
    );
  }

  createNewPassword(): void {
    const request: AuthRequestDTO = {
      profileDto: this.getProfile(this.createNewPasswordId),
      password: this.newPassword,
    };
    
    this._loginService.createNewPassword(request).subscribe((response: any) => {
      this._errorHandlerService.checkAndShowpageError(response.responseCode, 'login');
      
      if (response.token) {
        localStorage.setItem('token_key', response.token);
      }
      
      if (response.responseCode === '200') {
        this.showPasswordChangedSuccess = true;
      } else {
        this.resetLinkErrorMessage = response.responseMessage;
        this.showResetLinkErrorMessage = true;
      }
    });
  }

  // Login flow
  onSubmit(): void {
    const profile = this.getProfile(this.username);
    localStorage.setItem('userEmailFor2FA', this.username);
    
    this.responseErrorMessage = '';
    this.isLoading = true;

    this._loginService.login({ profileDto: profile, password: this.password }).subscribe((response) => {
      if (response.responseCode === '200') {
        localStorage.setItem('token_key', response.token);
        this.getAllStatus2FA();
        this.showHideNewDashboardPage();
      } else {
        this.handleLoginError();
      }
    });
  }

  private handleLoginError(): void {
    this.twoFaVerification = false;
    this.showLoginPage = true;
    this.loginMsg = 'Log in';
    this.isLoading = false;
    this.showLoader = false;
    this.responseErrorMessage = 'Incorrect username or password';
    this.showResponseErrorMessage = true;
  }

  // 2FA flow
  getAllStatus2FA(): void {
    this._twofactorAuthenticationService.getUser2FAStatus(localStorage.getItem('userEmailFor2FA')!)
      .subscribe((response: any) => {
        this._errorHandlerService.checkAndShowpageError(response.responseCode, 'login');
        localStorage.setItem('token_key', response.token);
        
        if (response.responseCode === '200') {
          this.process2FAResponse(response);
        }
      });
  }

  private process2FAResponse(response: any): void {
    this.isLoading = false;
    this.firstTimeLoginFlag = response.result.responseData.firstTimeLoginFlag;
    this.orgFlag = response.result.responseData.orgFlag;
    this.user2FAFlag = response.result.responseData.userFlag;
    
    if (this.user2FAFlag != undefined || this.user2FAFlag != null) {
      this.getOrgStatus();
    }
    
    localStorage.setItem('orgFlag2Fa', this.orgFlag.toString());
    localStorage.setItem('userFlag2Fa', this.user2FAFlag.toString());
    localStorage.setItem('firstTimeLogin', this.firstTimeLoginFlag.toString());
    this.id = response.result.responseData.id;
  }

  getOrgStatus(): void {
    const request: any = { orgId: '2312', flag: false };
    
    this._loginService.getUserProfileInfo(this.username, request).subscribe((response: any) => {
      this._errorHandlerService.checkAndShowpageError(response.responseCode, 'login');
      this.userProFileInfoDetailes = response;
      this._loginService.profileData.next(response);

      const profile: UserDTO = response;
      localStorage.setItem('token_key', profile.token);
      
      if (profile.responseCode === '200') {
        this.processOrgStatusResponse(profile);
      }
    });
  }

  private processOrgStatusResponse(profile: UserDTO): void {
    this.showOrgStatus = profile.result.responseData.orgProfileDto.status;
    
    if (this.showOrgStatus?.toUpperCase() === 'CLOSED') {
      this.orgActive = true;
      this.showLoginPage = false;
    } else {
      this.orgActive = false;
      this.show2faPage();
    }
  }

  show2faPage(): void {
    if (this.user2FAFlag && !this.firstTimeLoginFlag) {
      this.twoFaVerification = true;
      this.showLoginPage = false;
    } else {
      this.twoFaVerification = false;
      this.showLoginPage = true;
      this.getUserProfileInfo();
    }
  }

  // User profile and navigation
  getUserProfileInfo(): void {
    const request = { orgId: '2312', flag: false };

    this._loginService.getUsersForSubscription().subscribe((response: any) => {
      const profile: UserDTO = this.userProFileInfoDetailes;
      localStorage.setItem('token_key', profile.token);
      
      if (profile.responseCode === '200') {
        this.setupUserTracking(profile);
        this.processUserProfile(profile);
      }
    });
  }

  private setupUserTracking(profile: UserDTO): void {
    const userId = profile.result.responseData.profileDto.userId;
    
    gtag('config', 'G-SVCLTWBQRJ', { user_id: userId });
    gtag('config', 'G-VSV05EBFYX', { user_id: userId });
    gtag('config', 'G-MSKQPNXJ1G', { user_id: userId });
    gtag('set', 'user_properties', { crm_id: userId });
    
    this._dataLayerService.logCustomid(userId);
  }

  private processUserProfile(profile: UserDTO): void {
    this.storeUserDataInLocalStorage(profile);
    
    if (!profile.result.responseData.orgProfileDto.organisationType) {
      this.handleAdminUser(profile);
    } else if (profile.result.responseData.orgProfileDto.organisationType.toLowerCase() === 'partner') {
      this.handlePartnerUser(profile);
    } else if (profile.result.responseData.orgProfileDto.organisationType.toLowerCase() === 'regulator') {
      this.handleRegulatorUser(profile);
    }
  }

  private storeUserDataInLocalStorage(profile: UserDTO): void {
    const orgProfile = profile.result.responseData.orgProfileDto;
    const userProfile = profile.result.responseData.profileDto;
    
    localStorage.setItem('organisationName', orgProfile.organisationName);
    localStorage.setItem('partnerName', orgProfile.organisationName);
    localStorage.setItem('organisationId', orgProfile.organisationID + '');
    localStorage.setItem('orgStatus', orgProfile.status);
    localStorage.setItem('email', userProfile.email!);
    localStorage.setItem('userId', userProfile.userId!);
    localStorage.setItem('userName', `${userProfile.firstName} ${userProfile.lastName}`);
    localStorage.setItem('userRole', profile.result.responseData.roles.roleName);
    localStorage.setItem('lastPasswordChange', profile.result.responseData.resetPasswordCreateDate);
  }

  private handleAdminUser(profile: UserDTO): void {
    localStorage.setItem('user', 'admin');
    this.getAccessibleOptionsForAdmin();
    this._interactionService.setContries(this.contriesList);
    
    if (this.firstTimeLoginFlag || (this.orgFlag && !this.user2FAFlag)) {
      this.setup2FA = true;
      this.getUser2FAStatus(localStorage.getItem('userEmailFor2FA')!);
    }
  }

  private handlePartnerUser(profile: UserDTO): void {
    localStorage.setItem('partnerType', profile.result.responseData.orgProfileDto.partnerType);
    localStorage.setItem('selectedPartner', profile.result.responseData.orgProfileDto.partnerCode);
    localStorage.setItem('user', 'partner');
    sessionStorage.setItem('user', localStorage.getItem('user') === 'partner' ? 'partner' : 'admin');
    
    localStorage.setItem('partnerCode', profile.result.responseData.orgProfileDto.partnerCode);
    localStorage.setItem('multiFeeFlag', profile.result.responseData.orgProfileDto.multiFlag!);
    localStorage.setItem('headerName', 'Dashboard');
    
    this.getAccessibleOptions('Dashboard');
  }

  private handleRegulatorUser(profile: UserDTO): void {
    localStorage.setItem('partnerType', profile.result.responseData.orgProfileDto.partnerType);
    localStorage.setItem('selectedPartner', profile.result.responseData.orgProfileDto.partnerCode);
    localStorage.setItem('user', 'regulator');
    
    if (profile.result.responseData.orgProfileDto.typeUser === 'zoneUser') {
      this.contriesList = profile.result.responseData.orgProfileDto.countryList.map((c: any) => c.countryName);
      localStorage.setItem('userType', 'zoneUser');
      localStorage.setItem('countryList', JSON.stringify(this.contriesList));
      // @ts-ignore
      localStorage.setItem('zoneName', profile.result.responseData.orgProfileDto.zoneName);
    } else {
      this.contriesList = [profile.result.responseData.orgProfileDto.countryList[0].countryName];
      localStorage.setItem('userType', 'countryUser');
      localStorage.setItem('countryList', JSON.stringify(this.contriesList[0]));
    }
    
    this.initializeRegulatorStates();
    this._interactionService.setContries(this.contriesList);
  }

  private initializeRegulatorStates(): void {
    const emptyState = {
      datePicker: '',
      dateRange: 'This week',
      destinationTypeFilter: '',
      productFilter: '',
      selectedCountry: '',
    };
    
    this._state.setStatisticsConsumer(emptyState);
    this._state.setStatisticsTransaction(emptyState);
    this._state.setMoneyFlowsSend({ ...emptyState, direction: '', sendCountry: '' } as MoneyFlowsSendState);
    this._state.setMoneyFlowsReceive({ ...emptyState } as MoneyFlowsSendState);
    this._state.setCompliance(emptyState as ComplianceState);
  }

  // Access control methods
  getAccessibleOptions(menuName: string): void {
    const orgId = localStorage.getItem('organisationId') || '';
    const userRole = localStorage.getItem('userRole');

    this._rolesService.getRoleList(orgId).subscribe((response: any) => {
      this._errorHandlerService.checkAndShowpageError(response.responseCode, 'login');
      this._rolesService.getOrglistApi.next(response);
      this.adminRoleList = response;
      localStorage.setItem('AdminRoleList', JSON.stringify(this.adminRoleList));
      
      if (this.adminRoleList.token) {
        localStorage.setItem('token_key', this.adminRoleList.token);
      }
      
      if (this.adminRoleList?.result?.responseData) {
        const accessibleOptions = this.extractAccessibleOptions(userRole);
        this.showHideAccesses(accessibleOptions);
      }
    });
  }

  private extractAccessibleOptions(userRole: string | null): string[] {
    const accessibleOptions: string[] = [];
    
    for (const role of this.adminRoleList.result.responseData) {
      if (role.roleName === userRole && role.menuActionDTOList) {
        for (const menuAction of role.menuActionDTOList) {
          if (this.isRelevantMenu(menuAction.menuName)) {
            accessibleOptions.push(menuAction.menuAcionName);
          }
        }
      }
    }
    
    return accessibleOptions;
  }

  private isRelevantMenu(menuName: string): boolean {
    return [
      'Transaction',
      'Balance',
      'Dashboard',
      'Role',
      'User'
    ].includes(menuName);
  }

  showHideAccesses(options: string[]): void {
    const access = {
      canViewDashboard: options.includes('View Dashboard'),
      canViewTransaction: options.includes('View Transaction Detail'),
      canViewBalance: options.includes('View Balance Detail\n'),
      canViewSettings: [
        'View Roles',
        'Invite User',
        'Edit User',
        'Delete User'
      ].some(opt => options.includes(opt))
    };

    this.canAccess = access;
    this.navigateBasedOnAccess(access);
  }

  private navigateBasedOnAccess(access: CanAccessDashboard): void {
    if (access.canViewDashboard) {
      this.navigateToDashboard();
    } else if (access.canViewTransaction) {
      this.navigateToTransactions();
    } else if (access.canViewBalance) {
      this.navigateToBalance();
    } else if (access.canViewSettings) {
      this.navigateToSettings();
    } else {
      this.navigateToDefault();
    }
  }

  private navigateToDashboard(): void {
    if (this.firstTimeLoginFlag || (this.orgFlag && !this.user2FAFlag)) {
      return this.handleFirstTimeLogin();
    }
    if (this.showNewDashbordMenu) {
      localStorage.setItem('showDashboard', 'show');
      localStorage.setItem('activeSide', 'dashboard');
      this._router.navigate(['/papi/newDashboard']);
    } else {
      console.log('am i here!')
      localStorage.setItem('showDashboard', 'show');
      this._router.navigate(['/papi/dashboard']);
      localStorage.setItem('activeSide', 'dashboard');
    }
  }

  private navigateToTransactions(): void {
    if (this.firstTimeLoginFlag || (this.orgFlag && !this.user2FAFlag)) {
      return this.handleFirstTimeLogin();
    }
    this._router.navigate(['/papi/transaction']);
    localStorage.setItem('activeSide', 'transactions');
  }

  private navigateToBalance(): void {
    this._router.navigate(['/papi/balance']);
    localStorage.setItem('activeSide', 'balance');
  }

  private navigateToSettings(): void {
    this._router.navigate(['/papi/settings']);
    localStorage.setItem('activeSide', 'setting');
  }

  private navigateToDefault(): void {
    if (this.firstTimeLoginFlag || (this.orgFlag && !this.user2FAFlag)) {
      return this.handleFirstTimeLogin();
    }
    if (this.showNewDashbordMenu) {
      localStorage.setItem('showDashboard', 'hide');
      this._router.navigateByUrl('/papi/newDashboard');
      localStorage.setItem('activeSide', 'newDashboard');
    } else {
      console.log('am i here!2')
      console.log('am i here!')
      this._router.navigateByUrl('/papi/dashboard');
      localStorage.setItem('activeSide', 'volumes');
    }
    
  }

  private handleFirstTimeLogin(): void {
    if (this.firstTimeLoginFlag || (this.orgFlag && !this.user2FAFlag)) {
      this.setup2FA = true;
      this.getUser2FAStatus(localStorage.getItem('userEmailFor2FA')!);
    }
  }

  getAccessibleOptionsForAdmin(): void {
    const orgId = localStorage.getItem('organisationId') || '';
    const userRole = localStorage.getItem('userRole');

    this._rolesService.getRoleList(orgId).subscribe((response: any) => {
      this._errorHandlerService.checkAndShowpageError(response.responseCode, 'login');
      this.adminRoleList = response;
      localStorage.setItem('AdminRoleList', JSON.stringify(this.adminRoleList));
      
      if (this.adminRoleList.token) {
        localStorage.setItem('token_key', this.adminRoleList.token);
      }
      
      if (this.adminRoleList?.result?.responseData) {
        const accessibleOptions = this.extractAdminAccessibleOptions(userRole);
        this.showHideAccessesForAdmin(accessibleOptions);
      }
    });
  }

  private extractAdminAccessibleOptions(userRole: string | null): string[] {
    const accessibleOptions: string[] = [];
    
    for (const role of this.adminRoleList.result.responseData) {
      if (role.roleName === userRole && role.menuActionDTOList) {
        for (const menuAction of role.menuActionDTOList) {
          if (this.isRelevantAdminMenu(menuAction.menuName)) {
            accessibleOptions.push(menuAction.menuAcionName);
          }
        }
      }
    }
    
    return accessibleOptions;
  }

  private isRelevantAdminMenu(menuName: string): boolean {
    return [
      'Transaction',
      'Balance',
      'Zone',
      'Role',
      'User',
      'Group',
      'Organization',
      'STR Report',
      'Customer Report',
      'Value/volume'
    ].includes(menuName);
  }

  showHideAccessesForAdmin(options: string[]): void {
    const access = {
      canViewTransaction: options.includes('View Transaction Detail'),
      canViewBalance: options.includes('View Balance Detail\n'),
      canViewVolumes: options.includes('View Value/Volume'),
      canViewGoAml: options.includes('View STR Report'),
      canViewCustomerReport: options.includes('View Customer Report'),
      canViewOrganization: options.includes('View Organisation'),
      canviewGroup: options.includes('View Group'),
      canViewZone: options.includes('View Zone'),
      canViewSettings: [
        'View Roles',
        'Invite User',
        'Edit User',
        'Delete User'
      ].some(opt => options.includes(opt))
    };

    this.canAccessForAdmin = access;
    this.navigateBasedOnAdminAccess(access);
  }

  private navigateBasedOnAdminAccess(access: CanAccessAdminRight): void {
    if (access.canViewVolumes) {
      this.navigateToAdminDashboard();
    } else if (access.canViewTransaction) {
      this.navigateToAdminTransactions();
    } else if (access.canViewBalance) {
      this.navigateToAdminBalance();
    } else if (access.canViewGoAml) {
      this.navigateToSTRReport();
    } else if (access.canViewCustomerReport) {
      this.navigateToCustomerReport();
    } else if (access.canViewOrganization) {
      this.navigateToOrganization();
    } else if (access.canviewGroup) {
      this.navigateToGroups();
    } else if (access.canViewZone) {
      this.navigateToZones();
    } else if (access.canViewSettings) {
      this.navigateToAdminSettings();
    }
  }

  private navigateToAdminDashboard(): void {
    if (this.firstTimeLoginFlag || (this.orgFlag && !this.user2FAFlag)) {
      return this.handleFirstTimeLogin();
    }
    if (this.showNewDashbordMenu) {
      localStorage.setItem('showDashboard', 'hide');
      this._router.navigateByUrl('/papi/newDashboard');
      localStorage.setItem('activeSide', 'newDashboard');
    } else {
      console.log('am i here!')
      this._router.navigateByUrl('/papi/dashboard');
      localStorage.setItem('activeSide', 'dashboard');
    }
  }

  private navigateToAdminTransactions(): void {
    localStorage.setItem('showDashboard', 'show');
    this._router.navigate(['/papi/transaction']);
    localStorage.setItem('activeSide', 'transactions');
  }

  private navigateToAdminBalance(): void {
    this._router.navigate(['/papi/balance']);
    localStorage.setItem('activeSide', 'balance');
  }

  private navigateToSTRReport(): void {
    this._router.navigate(['/papi/strReport']);
    localStorage.setItem('activeSide', 'strReport');
  }

  private navigateToCustomerReport(): void {
    this._router.navigate(['/papi/customerReport']);
    localStorage.setItem('activeSide', 'customerStats');
  }

  private navigateToOrganization(): void {
    this._router.navigate(['/papi/organisation']);
    localStorage.setItem('activeSide', 'organisation');
  }

  private navigateToGroups(): void {
    this._router.navigate(['/papi/groups']);
    localStorage.setItem('activeSide', 'group');
  }

  private navigateToZones(): void {
    this._router.navigate(['/papi/zones']);
    localStorage.setItem('activeSide', 'zone');
  }

  private navigateToAdminSettings(): void {
    this._router.navigate(['/papi/settings']);
    localStorage.setItem('activeSide', 'setting');
  }

  // 2FA methods
  submit2FA(value: Array<string>): void {
    this.loginwith2FA(value.join(''));
  }

  loginwith2FA(code: string): void {
    this.isLoading = true;
    this.codeReady = true;
    this.showLoader2fa = true;
    
    this._twofactorAuthenticationService.validateUser(this.id, code).subscribe((response: any) => {
      if (response.responseCode === 'E402') {
        this.codeReady = false;
        this._generalService.sendNote({
          text: response.responseMessage,
          duration: 10000,
          type: 'danger',
        });
        return;
      }
      
      localStorage.setItem('token_key', response.token);
      
      if (response.responseCode == '200') {
        this.codeReady = false;
        this.getUserProfileInfo();
        localStorage.setItem('activeSide', 'volumes');
        this.showErrorMsg = false;
        this.showLoader2fa = false;
      } else {
        this.showErrorMsg = true;
      }
    });
  }

  reset(): void {
    this.showResetModal = true;
  }

  reset2FA(): void {
    this._twofactorAuthenticationService.reset2FA(localStorage.getItem('userEmailFor2FA')!)
      .subscribe((response: any) => {
        this._errorHandlerService.checkAndShowpageError(response.responseCode, 'reset 2fa');
        localStorage.setItem('token_key', response.token);
        
        if (response.responseCode === '200') {
          this.showResetModal = false;
          this.resetEmailSent = true;
          this.showLoader = false;
        }
      });
  }

  resetRequest2FA(): void {
    this.route.queryParams.subscribe((params: any) => {
      this.link2fa = params.link;
      this.type2fa = params.type;

      if (this.link2fa && this.type2fa && this.type2fa == 'reset-2fa') {
        this._twofactorAuthenticationService.reset2FAlink(this.link2fa).subscribe((response: any) => {
          this._errorHandlerService.checkAndShowpageError(response.responseCode, 'login');
          
          if (response.token) {
            localStorage.setItem('token_key', response.token);
          }
          
          if (response.responseCode === '200') {
            this.resetTwoFAFlag = true;
            this._generalService.sendNote({
              text: response.responseMessage,
              duration: 2000,
              ype: 'success',
            });
          }
          else{
            this._generalService.sendNote({
              text: response.responseMessage,
              duration: 2000,
              type: 'danger',
            });
          }
        });
      }
    });
  }

  getUser2FAStatus(userEmail: string): void {
    this._twofactorAuthenticationService.getUser2FAStatus(userEmail).subscribe((response: any) => {
      this._errorHandlerService.checkAndShowpageError(response.responseCode, '2fa dialog');
      localStorage.setItem('token_key', response.token);
      
      this.id = response.result.responseData.id;
      this.orgFlag = response.result.responseData.orgFlag;
      this.userFlag = response.result.responseData.userFlag;
      this.firstTimeLoginFlag = response.result.responseData.firstTimeLoginFlag;
      
      this.getQRCode();
    });
  }

  getQRCode(): void {
    this._twofactorAuthenticationService.getQRCode(this.id).subscribe((response: any) => {
      this._errorHandlerService.checkAndShowpageError(response.responseCode, '2fa dialog');
      localStorage.setItem('token_key', response.token);
      
      this.QRcodeImage = response.result.responseData.qr_code_image;
      this.authenticationKey = response.result.responseData.auth_key;
      this.image = this.sanitizer.bypassSecurityTrustUrl(this.imageType + this.QRcodeImage);
      
    });
  }

  skipButton(): void {
    this._twofactorAuthenticationService.updateFirstTimeLogin(this.id, !this.firstTimeLoginFlag)
      .subscribe((response: any) => {
        this._errorHandlerService.checkAndShowpageError(response.responseCode, '2fa dialog');
        localStorage.setItem('token_key', response.token);
        
        if (response.responseCode == '200') {
          localStorage.setItem('orgFlag2Fa', 'false');
          localStorage.setItem('userFlag2Fa', 'true');
          localStorage.setItem('firstTimeLogin', 'false');
        }
      });
    
    this.setup2FA = false;
  }

  enableUser2FA(code: any): void {
    this.codeReady = true;
    this.isLoading = true;
    
    this._twofactorAuthenticationService.enableUser2FA(this.id, code.join('')).subscribe((response: any) => {
      this._errorHandlerService.checkAndShowpageError(response.responseCode, '2fa dialog');
      localStorage.setItem('token_key', response.token);
      
      if (response.responseCode == '200') {
        this.isLoading = false;
        localStorage.setItem('orgFlag2Fa', 'false');
        localStorage.setItem('userFlag2Fa', 'true');
        localStorage.setItem('firstTimeLogin', 'false');
        console.log('am i here!')
        this._router.navigateByUrl('/papi/dashboard');
        localStorage.setItem('activeSide', 'volumes');
      }
    });
  }

  sendResetLink(): void {
    const request: AuthRequestDTO = {
      profileDto: this.getProfile(this.passwordResetEmail),
      password: '',
    };
    
    this._loginService.sendResetPasswordLink(request).subscribe((response: any) => {
      this._errorHandlerService.checkAndShowpageError(response.responseCode, 'login');
      
      if (response.token) {
        localStorage.setItem('token_key', response.token);
      }
      
      if (response.responseCode === '200') {
        this.resetEmailSent = true;
      }
    });
  }

  // UI state methods
  showResetPasswordMethod(): void {
    this.showResetPassword = true;  // Add this line
    this.showCreatePass = true;
    this.showLoginPage = false;
    this.showPassReset = false;
    this.showConfirmPass = false;
    this.showResetLinkSent = false;
  }

  showLogin(): void {
    this.showResetPassword = false;  // Add this line
    this.showLoginPage = true;
    this.showPassReset = false;
    this.showCreatePass = false;
    this.showConfirmPass = false;
    this.showResetLinkSent = false;
  }

  viewApps(): void {
    this.showApps = true;
  }

  hideApps(): void {
    this.showApps = false;
  }

  showHideNewDashboardPage(): void {
    this._settingsService.newDashboardPage().subscribe((response: any) => {
      this._errorHandlerService.checkAndShowpageError(response.responseCode, 'sidebar');
      
      if (response.token) {
        localStorage.setItem('token_key', response.token);
      }
      
      localStorage.setItem('NewDashboard', JSON.stringify(response));
      
      if (response.responseCode == 200) {
        this.moduleName = response.result.responseData[0].moduleName;
        this.moduleStatus = response.result.responseData[0].partnerCode;
        
        this.showNewDashbordMenu = 
          this.moduleName.includes('NewDashboardPage') && 
          this.moduleStatus.includes('enable');
      }
    });
  }

  // Helper methods
  getProfile(username: string): ProfileDTO {
    return {
      email: username,
      addressDtoList: undefined,
      dateOfBirth: undefined,
      firstName: undefined,
      idDto: undefined,
      emailVerified: undefined,
      lastName: undefined,
      mobileNumber: undefined,
      status: undefined,
      timeZoneDto: undefined,
      idTypeList: undefined,
      countryCode: undefined,
    };
  }
}